module.exports = __webpack_public_path__ + "static/media/top_bg.cfd4bd8d.svg";